import { RawQuoteInfos } from './QuoteInfos';
import { connectQuoteInfos } from './QuoteInfos.connect';
export const QuoteInfos = connectQuoteInfos(RawQuoteInfos);
